var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlatPickr',{staticClass:"input input_light",attrs:{"config":_vm.config,"placeholder":"Период","required":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }